<template>
  <div id="overlay">
    <div id="content">
      <div class="row row-margin">
        <div class="col-12">
          <button class="btn btn-sm btn-outline-primary" v-on:click="add">
            追加する
          </button>
          <button
            class="btn btn-sm btn-outline-info modal-close"
            v-on:click="closeModal"
          >
            キャンセルする
          </button>
        </div>
      </div>
      <div class="row row-margin">
        <div class="col-12 form-inline">
          <div class="col-12">
            メンバーを検索して [追加する] をクリックしてください
          </div>
          <div id="select-form" class="border rounded">
            <p v-if="isAddUsers" id="select-caution"></p>
            <div
              class="form-inline border rounded select-item"
              v-for="addUser in addUsers"
              v-bind:key="addUser.id"
            >
              {{ addUser.userName }}
              <button
                class="btn btn-sm .border.border-0"
                v-on:click="removeUser(addUser.id)"
              >
                <img class="times-solid-sm" src="/times-solid.svg" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <form
        class="input-group"
        @submit.prevent="searchUser(searchKey, selectedOrgId)"
      >
        <input
          type="text"
          class="form-control"
          placeholder="ID、名称、かな"
          v-model="searchKey"
        />
        <div class="input-group-append">
          <button class="btn btn-secondary" type="submit">
            <img class="search-solid" src="/search-solid.svg" />
          </button>
        </div>
      </form>
      <div class="row" style="margin-top: 10px">
        <div class="col-12 d-flex d-flex align-items-center">
          <label>所属（組織）からメンバーを検索する</label>
        </div>
        <div class="col-6">
          <select
            class="form-control"
            v-model="selectedOrgId"
            @change="searchUser(searchKey, selectedOrgId)"
          >
            <option value="">所属（組織）を選択してください</option>
            <option
              v-for="option in organizationOptions"
              v-bind:value="option.id"
              v-bind:key="option.id"
            >
              {{ option.displayName }}
            </option>
          </select>
        </div>
        <div class="col-6 d-flex align-items-center">
          <div v-if="selectedOrgId !== ''">
            <button
              class="btn btn-sm btn-outline-info modal-close text-left"
              @click="clearOrgSelection"
            >
              所属（組織）の選択を解除する
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <p></p>
      </div>
      <div class="table-scroll">
        <table class="table table-sm table-hover form-table">
          <thead>
            <tr>
              <th scope="col" style="width: 50px; border: none"></th>
              <th scope="col" style="width: 95px; border: none">ID</th>
              <th scope="col" style="width: 110px; border: none">ユーザー名</th>
              <th scope="col" style="width: 110px; border: none">所属</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="searchUser in searchUsers" v-bind:key="searchUser.id">
              <td>
                <button
                  type="button"
                  class="btn-sm"
                  v-on:click="addUser(searchUser.id)"
                >
                  <img class="plus-solid" src="/plus-solid.svg" />
                </button>
              </td>
              <td>{{ searchUser.userCode }}</td>
              <td>{{ searchUser.userName }}</td>
              <td>{{ searchUser.organization.affiliation }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <nav aria-label="pager">
        <ul class="pagination justify-content-center">
          <li v-if="isPrev" v-on:click="goPrev">
            <a class="btn page-link rounded-pill">&larr; 前</a>
          </li>
          <li v-if="isPrev || isNext" class="mx-2">
            <a class="btn page-link rounded-pill">現在</a>
          </li>
          <li v-if="isNext" v-on:click="goNext">
            <a class="btn page-link rounded-pill">次 &rarr;</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { sessions } from "../mixin/session";
import { headers } from "../mixin/headers";

/* eslint-disable */
// 下位コンポーネントから上位コンポーネントを変更しようとしている。 20230901
export default {
  name: "MemberModal",
  mixins: [sessions, headers],
  data: function () {
    return {
      searchKey: "",
      searchUsers: [],
      addUsers: [],
      historyId: 0,
      organizationOptions: [],
      selectedOrgId: "",
      gridCount: 0,
      currentIndex: 0,
      limit: 20,
    };
  },
  props: ["members", "parentName", "exclusionId", "realms"],
  created() {
    //組織一覧取得
    this.$cognito
      .isAuthenticated()
      .then((session) => {
        if (session) {
          var accessToken = this.getAccessToken(this.$cognito, session);
          var hospitalId = this.$store.getters.hospital.id;
          axios
            .get("/api/organization/management/historylist/" + hospitalId, {
              headers: this.headers(accessToken),
            })
            .then((response) => {
              this.historyId = response.data.data.historyId;
              axios
                .post(
                  "/api/organization/management/belonglist/",
                  {
                    hospitalId: hospitalId,
                    historyId: this.historyId,
                  },
                  {
                    headers: this.headers(accessToken),
                  }
                )
                .then((response) => {
                  this.organizationOptions =
                    response.data.data.organizations.filter(
                      (option) => option.displayName
                    );
                })
                .catch((err) => {
                  throw err;
                });
            })
            .catch((err) => {
              throw err;
            });
        }
      })
      .catch((err) => {
        this.message = err.message;
      });
  },
  mounted() {
    this.initModal();
  },
  methods: {
    initModal() {
      this.clearOrgSelection();
      this.searchUsers = [];
      this.addUsers = [];
    },
    closeModal() {
      this.$emit("close-modal");
      this.initModal();
    },
    getUsers(session, searchKey, selectedOrgId) {
      var accessToken = this.getAccessToken(this.$cognito, session);
      var hospitalId = this.$store.getters.hospital.id;
      var exclusionId = Number(this.exclusionId);
      var offset = this.currentIndex * this.limit;

      if (exclusionId === -1) {
        return axios.post(
          "/api/user/list/management/" + offset,
          {
            hospitalId: hospitalId,
            searchKey: searchKey,
            selectedOrgId: selectedOrgId,
          },
          {
            headers: this.headers(accessToken),
          }
        );
      } else {
        if (this.parentName === "teams") {
          return axios.post(
            "/api/user/list/without/chatroom/" + offset,
            {
              hospitalId: hospitalId,
              roomId: exclusionId,
              searchKey: searchKey,
              selectedOrgId: selectedOrgId,
            },
            {
              headers: this.headers(accessToken),
            }
          );
        } else {
          return axios.post(
            "/api/user/list/without/emergency/" + offset,
            {
              hospitalId: hospitalId,
              roomId: exclusionId,
              searchKey: searchKey,
              selectedOrgId: selectedOrgId,
            },
            {
              headers: this.headers(accessToken),
            }
          );
        }
      }
    },
    searchUser(searchKey, selectedOrgId) {
      this.$cognito
        .isAuthenticated()
        .then((session) => {
          if (session) {
            this.getUsers(session, searchKey, selectedOrgId)
              .then((response) => {
                var res = response.data;
                if (res.errorMessage) {
                  this.message = res.errorMessage;
                } else {
                  var targets = [];
                  this.members.forEach((element) => {
                    targets.push(element.userId);
                  });
                  this.addUsers.forEach((element) => {
                    targets.push(element.id);
                  });
                  var users = res.data.users.filter((element) => {
                    return targets.every(
                      (currentValue) => currentValue != element.id
                    );
                  });
                  this.searchUsers = [];

                  this.searchUsers = users;
                  this.gridCount = res.data.users.length;
                }
              })
              .catch((err) => {
                throw err;
              });
          }
        })
        .catch((err) => {
          this.message = err.message;
        });
    },
    //選択した組織とユーザー一覧,次へ/前へボタンをクリア
    clearOrgSelection() {
      this.selectedOrgId = "";
      this.searchUsers = [];
      this.gridCount = 0;
      this.currentIndex = 0;
    },
    goNext() {
      this.currentIndex++;
      this.searchUser(this.searchKey, this.selectedOrgId);
    },
    goPrev() {
      this.currentIndex--;
      this.searchUser(this.searchKey, this.selectedOrgId);
    },
    addUser(id) {
      var user = this.searchUsers.find((element) => element.id === id);
      this.addUsers.push(user);
      var index = this.searchUsers.findIndex((element) => element.id === id);
      this.searchUsers.splice(index, 1);
    },
    removeUser(id) {
      var user = this.addUsers.find((element) => element.id === id);
      this.searchUsers.push(user);
      var index = this.addUsers.findIndex((element) => element.id === id);
      this.addUsers.splice(index, 1);
      var sortlist = this.searchUsers.sort(function (a, b) {
        return a.userCode > b.userCode === true ? 1 : -1;
      });
      this.searchUsers = sortlist;
    },
    add() {
      if (this.parentName === "teams") {
        this.addUsers.forEach((element) => {
          this.members.push({
            userId: element.id,
            user: {
              userCode: element.userCode,
              userName: element.userName,
            },
          });
        });
        var teamlist = this.members.sort(function (a, b) {
          return a.user.userCode > b.user.userCode === true ? 1 : -1;
        });
        this.$emit("add-member", teamlist);
      } else {
        this.addUsers.forEach((element) => {
          this.members.push({
            userId: element.id,
            privilege: "1",
            User: {
              userCode: element.userCode,
              userName: element.userName,
            },
          });
        });
        var sortlist = this.members.sort(function (a, b) {
          return a.User.userCode > b.User.userCode === true ? 1 : -1;
        });
        this.$emit("add-member", sortlist);
      }

      this.initModal();
    },
  },
  computed: {
    isAddUsers: function () {
      return this.addUsers.length === 0;
    },
    isNext: function () {
      return this.gridCount === this.limit;
    },
    isPrev: function () {
      return this.currentIndex !== 0;
    },
  },
};
</script>

<style scoped>
#overlay {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
#content {
  z-index: 2;
  width: 50%;
  padding: 1em;
  background: #fff;
}
.modal-close {
  float: right;
}
.row-margin {
  margin-bottom: 10px;
}
.search-solid {
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.table-scroll {
  position: relative;
  height: 400px;
  overflow: auto;
}
.table-scroll thead tr {
  position: sticky;
  top: 0;
  /* background-color: #fff; */
  background-color: #353a3f;
  color: #fff;
  border-bottom: 3px solid #ccc;
  z-index: 1;
}
.table-hover tbody tr:hover {
  background-color: #fff;
}
#select-form {
  width: 100%;
  min-height: 35px;
}
#select-caution {
  margin-top: 5px;
  margin-left: 5px;
  margin-bottom: 0;
}
.select-item {
  display: inline;
}
.plus-solid {
  cursor: pointer;
  height: 15px;
  width: 15px;
}
.times-solid-sm {
  cursor: pointer;
  height: 12px;
  width: 12px;
}
</style>
